import { Button, Grid, Group, Modal, Stack, Text, TextInput, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { infoUrl } from './ChatBot';

export function BaseInputPage(props: { onChange: (context: BaseInputField) => void; onNext: () => void }) {
    const [awaitingSubmit, setAwaitingSubmit] = useState(false);
    const form = useForm<BaseInputField>({
        initialValues: {
            name: '',            // 個人稱呼
            mobile: '',             // 聯絡手機
            email: '',              // 電子郵件
        },
        validate: {
            name: (value) => !value ? '請輸入姓名' : null,
            email: (value) => {
                if (!value) return '請輸入電子郵件';
                // 簡單的電子郵件格式驗證
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    return '請輸入正確的電子郵件格式';
                }
            },
            mobile: (value) => {
                if (!value) return '請輸入聯絡手機';
                // 台灣手機號碼格式：09xxxxxxxx
                const phoneRegex = /^09\d{8}$/;
                // 或者更寬鬆的格式：支援市話和手機
                const flexiblePhoneRegex = /^(0\d{1,2}-?\d{7,8}|09\d{8})$/;

                if (!flexiblePhoneRegex.test(value.replace(/\s|-/g, ''))) {
                    return '請輸入正確的電話號碼格式';
                }
                return null;
            },
        }
    });

    const handleSubmit = async (values: BaseInputField) => {
        if (awaitingSubmit) return;
        setAwaitingSubmit(true);
        props.onChange(values);
        // 存入 Google 表單
        try {
            const formId = "1FAIpQLSctpr3Xc5RYprRkwhyE9EcsE2ol6GIJPS8XqjnG30nswPkHFw";
            const googleFormUrl = `https://docs.google.com/forms/d/e/${formId}/formResponse`;

            const formData = new FormData();
            formData.append('entry.905125100', values.name);
            formData.append('entry.1536666058', values.mobile);
            formData.append('entry.1846776684', values.email);

            // 提交到 Google 表單
            // await fetch(googleFormUrl, {
            //     method: 'POST',
            //     mode: 'no-cors', // 重要：Google 表單需要 no-cors 模式
            //     body: formData
            // });

            // 提交成功後執行下一步
            props.onNext();

        } catch (error) {
            console.error('提交 Google 表單時發生錯誤:', error);
            // 即使 Google 表單提交失敗，也繼續下一步
            props.onNext();
        } finally {
            setAwaitingSubmit(false);
        }
    };

    return <>
        <Modal
            opened={true}
            onClose={() => { }}
            withCloseButton={false}
            size={"xl"} // xs, sm, md, lg, xl
            styles={{
                content: {
                    borderRadius: '15px',
                    background: " linear-gradient(180deg, #241E1E 0%, #09080E 100%)",
                    border: '2px solid #C09C54',
                    overflow: 'hidden',
                },
                body: {
                    padding: '2rem',
                    maxHeight: '90vh',
                    overflowY: 'auto', // 啟用垂直滾動
                    overflowX: 'hidden', // 隱藏水平滾動
                },
            }}
            withOverlay={false}
        >
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <Stack gap="sm">
                    <Title order={2} ta="center" c="#BF9376">
                        AI地產業務客服員 - 試用體驗
                    </Title>
                    <Text c="#FAFAFA">
                        敬請留下您的資料，並點選「下一步」開始建立測試用資料。
                    </Text>
                    <TextInput
                        label="個人稱呼"
                        placeholder="請輸入個人稱呼"
                        required
                        {...form.getInputProps('name')}
                    />
                    <TextInput
                        label="聯絡手機"
                        placeholder="請輸入聯絡手機 (格式範例：0912345678)"
                        required
                        {...form.getInputProps('mobile')}
                    />
                    <TextInput
                        label="電子郵件"
                        placeholder="請輸入電子郵件 (格式範例：example@gmail.com)"
                        required
                        {...form.getInputProps('email')}
                    />
                    <Group justify="center" mt="md">
                        <Button type="submit" color='#A77145' disabled={awaitingSubmit}>下一步</Button>
                    </Group>
                </Stack>
            </form>
        </Modal >
    </>
}

export interface BaseInputField {
    name: string;                // 個人稱呼
    mobile: string;             // 聯絡手機
    email: string;              // 電子郵件
}